import { useRecoilValue } from "recoil";
import { taskSubmissionSearchAtom } from "../miscellaneous/taskSubmissionSearchAtom";

export const useTaskSubmissionSearchValue = () => {
  return useRecoilValue(taskSubmissionSearchAtom);
};
